<template>
	<div>
		<Header :sel='3' @changePhone="changePhone" />
		<!--neirong-->
		<div :class="['cd-main-content',showPhone?'nav-is-visible':'']">


			<!-- * 内页banner * -->
			<div class="page-banner">
				<img src="@/assets/images/banner04.png">
				<div class="nybt">
					<h3>业务范围</h3>
				</div>
			</div>
			
			<!-- * 当前位置 * -->
			<div class="page-position">
				<div class="wh">
					当前位置：
					<a href="/">首页</a>
					&gt;
					<a href="/product/">业务范围</a> > <a href="">{{title}}</a>
				</div>
			</div>
			
			<!-- * 主体部分 * -->
			<div class="page-wrap">
				<div class="wh clearfix">
					<!-- * 左侧 * -->
			
			
					<!-- * 右侧 * -->
					<div class="page-wrap-right">
			
						<div class="xypg-left-con2 hidden-sm hidden-xs clearfix">
							<div>
							</div>
						</div>
			
			
			
						<div class="xypg-right-content">
							<!-- * 判断后台有没有录入多图 * -->
							<div>
								<!-- 产品详情页面 -->
								<div class="xypg-product-detail">
			
			
									<div class="product-detail-tab">
			
			
										<div class="product-detail-tabbox">
											<div class="product-detail-tabcon">
												<div v-html="szData.cmsArticleData?szData.cmsArticleData.content:''"></div>
												
											</div>
										</div>
									</div>
									<!-- 产品列表页 -->
									
									<div class="pro_title">相关产品</div>
									<ul class="xypg-product-list clearfix">
										<li v-for="item in list" @click="goBusDetail(item.id)">
											<a href="javascript:void(0)" class="img"><img
													:src="item.image" /></a>
											<h3><a href="javascript:void(0)">{{item.title}}</a></h3>
										</li>
									</ul>
									<div class="xypg-pagination">
										<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
											:current-page="pageNum" :page-sizes="[9, 18, 45, 90]"
											:page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
											:total="total">
										</el-pagination>
									</div>
								</div>
							</div>
			
							<!-- * 最近浏览 * -->
							<!-- * 最近浏览 * -->
			
			
						</div>
					</div>
			
					<!-- * 手机弹窗 * -->
			
				</div>
			</div>

			<Footer />
		</div>



		<!--neirong-->


	</div>
</template>

<script>
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'
	import axios from 'axios';


	import {
		articleDetail,articleList
	} from '@/api/reqFetch.js'

	export default {
		name: '',
		layout: '',
		components: {
			Footer,
			Header,
		},
		data() {
			return {
				id: '',
				detail: {},
				showPhone: false,
				pdfUrl: '',
				pdfDoc: null,
				pageNum: 1,
				pageCount: 0,
				title:'',
				type:'',
				list: [],
				pageNum: 1,
				pageSize:9,
				total:0,
				szData:{}
			}
		},

		mounted() {
			if(this.$route.query.type){
				this.type=this.$route.query.type
				this.title=this.$route.query.title
			}
			this.goBus();
			this.list=[]
			this.szData={}
			this.getData()
		},

		methods: {
			goBusDetail(id){
				this.$router.push({
					path: '/productDetail?id='+id,
				})
			},
			// 页码容量变化
			handleSizeChange(pageSize) {
				this.pageNum = 1
				this.pageSize = pageSize
				this.getData()
			},
			
			// 当前页码变化
			handleCurrentChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			
			getData() {
				let par = {
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					status: 1,
					categoryCode:this.type,
					isComment:1
				}
				articleList(par).then(res => {
					this.list = res.rows;
					this.total = res.total
				});
			},
			goBus(){
				articleList({
					pageNum: 1,
					pageSize: 1,
					status: 1,
					categoryCode: this.type,
					isComment:0
				}).then(res => {
					if(res.rows.length>0){
						this.getSzDetail(res.rows[0].id)
					}
					
				});
			},
			getSzDetail(id){
				articleDetail({
					id: id
				}).then(res => {
					this.szData = res.data;
					try {
							let cmsArticleData = this.szData.cmsArticleData
						if(cmsArticleData && cmsArticleData.content){
							// 正则替换空格&nbsp;为一个div元素，
							cmsArticleData.content = cmsArticleData.content.replace(/&nbsp;&nbsp;&nbsp;&nbsp;/g, '<div class="su-space"></div>')
						}
						this.szData = {
							...this.szData,
							cmsArticleData: cmsArticleData
						}
					} catch (error) {
						console.error(error)
					}
							
				});
			},
			goNext(url) {
				this.$router.push({
					path: url,
				})
			},

			changePhone(val) {
				this.showPhone = val
			},
			getNewDetail() {
				articleDetail({
					id: this.id
				}).then(res => {
					this.detail = res.data;
					try {
							let cmsArticleData = this.detail.cmsArticleData
						if(cmsArticleData && cmsArticleData.content){
							// 正则替换空格&nbsp;为一个div元素，
							cmsArticleData.content = cmsArticleData.content.replace(/&nbsp;&nbsp;&nbsp;&nbsp;/g, '<div class="su-space"></div>')
						}
						this.detail = {
							...this.detail,
							cmsArticleData: cmsArticleData
						}
					} catch (error) {
						console.error(error)
					}
					this.fileList = res.data.fileList;
					if (res.data.fileList.length > 0 && res.data.fileList[0].fileExt == ".pdf") {
						// this.pdfUrl = res.data.fileList[0].url
						axios.get(res.data.fileList[0].url, {
							timeout: 60000,
							responseType: 'blob'
						}).then(res => {
							const binaryData = [];
							binaryData.push(res.data);
							let url = window.URL.createObjectURL(
								new Blob(binaryData, {
									type: "application/pdf"
								})
							)
							this.pdfUrl = url
						})

					}

				});
			},

			checkCategoryCode() {
				categorysortPage({
					pos: 'top'
				}).then(res => {
					if (this.level == 1) {
						res.data.map(item => {
							if (item.categoryCode == this.type) {
								this.selOneName = item.categoryName
								this.configList = item.children
							}
						})
					} else {
						res.data.map(item => {
							if (item.categoryCode == this.firstCategoryCode) {
								this.selOneName = item.categoryName
								this.configList = item.children
								this.configList.map(items => {
									if (items.categoryCode == this.type) {
										this.selName = items.categoryName
									}
								})
							}
						})
					}

				});
			},

		}
	}
</script>

<style scoped>
	/*内容*/
	.banner {
		/* background-image: url('../../assets/images/banner_03.png'); */
	}

</style>